module.exports = __webpack_public_path__ + "static/hamburger-cross-7cb1ebc01c9f2524cb5f0cce4eb0c45e.png";